import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.48959 16.5104C7.56978 19.5906 12.4258 19.8126 15.762 17.1765L21.1064 22.5209L22.5206 21.1067L17.1763 15.7623C19.8126 12.4261 19.5907 7.56987 16.5104 4.48959C13.191 1.17014 7.80905 1.17014 4.48959 4.48959C1.17014 7.80905 1.17014 13.191 4.48959 16.5104ZM14.5 11.5H11.5V14.5H9.5V11.5H6.5V9.5H9.5L9.5 6.5H11.5L11.5 9.5H14.5V11.5Z"}}]};

const ZoomInFilled = Vue.extend<IconProps>({
  name: 'ZoomInFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'zoom-in-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ZoomInFilled;
